// extracted by mini-css-extract-plugin
export default {"videoSection":"Step2_videoSection__rRVuC","back":"Step2_back__zwRU5","next":"Step2_next__yXG0q","sliderButton":"Step2_sliderButton__SKly2","content":"Step2_content__l6ykV"};